import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlRacBandeauResponse extends IIsiDtoPresentationLogicResponse  {
    result?: IIsiDtoPlRacBandeauResult;
}
export interface IIsiDtoPlRacBandeauResult extends IIsiDataTransferObject  {
    getMenu?: string;
}
export class IsiDtoPlRacBandeauResult extends IsiDataTransferObject implements IIsiDtoPlRacBandeauResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.RacBandeau.IsiDtoPlRacBandeauResult, Isilog.IsiComponent.IsiDataTransferObject";
    getMenu?: string;

    constructor(data?: IIsiDtoPlRacBandeauResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.getMenu = _data["getMenu"] !== undefined ? _data["getMenu"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlRacBandeauResult): IsiDtoPlRacBandeauResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlRacBandeauResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["getMenu"] = this.getMenu !== undefined ? this.getMenu : <any>null;
        return data;
    }
}
export class IsiDtoPlRacBandeauResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlRacBandeauResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.RacBandeau.IsiDtoPlRacBandeauResponse, Isilog.IsiComponent.IsiDataTransferObject";
    result?: IsiDtoPlRacBandeauResult;

    constructor(data?: IIsiDtoPlRacBandeauResponse) {
        super(data);
        if (data) {
            this.result = data.result && !(<any>data.result).toJSON ? new IsiDtoPlRacBandeauResult(data.result) : <IsiDtoPlRacBandeauResult>this.result;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] ? IsiDtoPlRacBandeauResult.fromJS(_data["result"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlRacBandeauResponse): IsiDtoPlRacBandeauResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlRacBandeauResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["result"] = this.result != null ? (<any>this.result).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlRacBandeauRequest extends IIsiDtoPresentationLogicRequest  {
    consKey?: number;
    key?: number;
    racName?: string;
    racType?: string;
    response?: IIsiDtoPlRacBandeauResponse;
}
export class IsiDtoPlRacBandeauRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlRacBandeauRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.RacBandeau.IsiDtoPlRacBandeauRequest, Isilog.IsiComponent.IsiDataTransferObject";
    consKey?: number;
    key?: number;
    racName?: string;
    racType?: string;
    response?: IsiDtoPlRacBandeauResponse;

    constructor(data?: IIsiDtoPlRacBandeauRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlRacBandeauResponse(data.response) : <IsiDtoPlRacBandeauResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.consKey = _data["consKey"] !== undefined ? _data["consKey"] : 0;
            this.key = _data["key"] !== undefined ? _data["key"] : 0;
            this.racName = _data["racName"] !== undefined ? _data["racName"] : <any>null;
            this.racType = _data["racType"] !== undefined ? _data["racType"] : <any>null;
            this.response = _data["response"] ? IsiDtoPlRacBandeauResponse.fromJS(_data["response"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlRacBandeauRequest): IsiDtoPlRacBandeauRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlRacBandeauRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["consKey"] = this.consKey !== undefined ? this.consKey : 0;
        data["key"] = this.key !== undefined ? this.key : 0;
        data["racName"] = this.racName !== undefined ? this.racName : <any>null;
        data["racType"] = this.racType !== undefined ? this.racType : <any>null;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        return data;
    }
}
